var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headerContainer"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo.png")}}),_vm._v(" "),_c('nav-bar')],1),_vm._v(" "),_c('div',{staticClass:"m_header"},[_c('div',{staticClass:"title"},[_vm._v("嘉信保险经纪")]),_vm._v(" "),_c('drop-down')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f3ffc6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 